import { GetterTree } from 'vuex';
import { State } from './vm.store';
import * as types from '@/store/modules/vm/vm-types';

const getters: GetterTree<State, State> = {
  GET_CURRENT_VM: state => {
    return state.currentVm;
  },
  GET_CURRENT_VM_INSTANCE: state => {
    return state.currentVmInstance;
  },
  GET_CURRENT_VM_SERVICE: state => {
    return state.currentVmService;
  },
  getAllVMServices: state => {
    return state.vmServices;
  },
  GET_VM_SUBTYPE: state => {
    return state.vmSubType;
  },
  [types.vmGetters.GET_VM_ATTRIBUTES]: state => {
    return state.attributes;
  },
  [types.vmGetters.GET_VM_ISACTIVE]: state => {
    return state.vmIsActive;
  },
  [types.vmGetters.GET_VM_AVAILABILITY]: state => {
    return state.vmAvailability;
  }
};
export default getters;
